import * as React from "react";

export default function Policy() {
  return (
    <div id="content">
      <h1>Zásady ochrany osobních údajů (Privacy Policy)</h1>
      <div id="lightbox-search">
        <p>
          HadejSlova.cz se zavazuje chránit Vaše soukromí. Tyto zásady ochrany
          osobních údajů vysvětlují, jakým způsobem aplikace HadejSlova.cz
          shromažďuje, používá a zveřejňuje Vaše osobní údaje.
        </p>
        <p>
          Tyto Zásady ochrany osobních údajů se vztahují na naše webové stránky
          a jejich přidružené subdomény (dále společně jen "naše služba") spolu
          s naší aplikací HadejSlova. Přístupem k naší službě nebo jejím
          používáním dáváte najevo, že jste si je přečetli, pochopili a
          souhlasíte se shromažďováním, ukládáním, používáním a zveřejňováním
          vašich osobních údajů, jak je popsáno v těchto Zásadách ochrany
          osobních údajů.&nbsp;
        </p>
        <h3>Definice a klíčové pojmy</h3>
        <p>
          Abychom Vám pomohli s objasněním všech pojmů, které jsou uvedeny v
          těchto Zásadách ochrany osobních údajů, uvádíme jejich definice:
        </p>
        <ul>
          <li>
            <strong>Cookie</strong>: malé množství dat generovaných webovou
            stránkou a uložených vaším webovým prohlížečem. Používá se k
            identifikaci prohlížeče, poskytování analytickýc služeb,
            zapamatování informací o vás, jako jsou vaše jazykové preference
            nebo přihlašovací údaje.
          </li>
          <li>
            <strong>Zařízení</strong>: jakékoli zařízení připojené k internetu,
            jako je telefon, tablet, počítač nebo jakékoli jiné zařízení, které
            lze použít k návštěvě HadejSlova.cz.
          </li>
          <li>
            <strong>IP adresa</strong>: Každé zařízení připojené k internetu má
            přiděleno číslo známé jako adresa internetového protokolu (IP). Tato
            čísla jsou obvykle přidělována v geografických blocích. IP adresu
            lze často použít k identifikaci místa, ze kterého se zařízení
            připojuje k internetu.
          </li>
          <li>
            <strong>Osobní údaje</strong>: veškeré informace, které přímo,
            nepřímo nebo ve spojení s jinými informacemi umožňují identifikaci
            nebo identifikovatelnost fyzické osoby.
          </li>
          <li>
            <strong>Služba</strong>: označuje službu poskytovanou aplikací
            HadejSlova, jak je popsána ve smluvních podmínkách (jsou-li k
            dispozici) a na této platformě.
          </li>
          <li>
            <strong>Služba třetí strany</strong>: odkazuje na inzerenty,
            sponzory soutěží, propagační a marketingové partnery a další
            subjekty, které poskytují náš obsah nebo jejichž produkty či služby
            vás podle našeho názoru mohou zajímat.
          </li>
          <li>
            <strong>Web nebo jinak také webové stránky</strong>: stránky, které
            jsou přístupné prostřednictvím této adresy{" "}
          </li>
          <li>
            <strong>Vy</strong>: fyzická nebo právnická osoba, která užívá hru
            HadejSlova.cz
          </li>
        </ul>
        <h3>Automaticky shromažďované informace</h3>
        <p>
          Při návštěvě naší platformy se automaticky shromažďují některé
          informace, jako je adresa internetového protokolu (IP) a/nebo
          charakteristiky prohlížeče a zařízení. Tyto informace mohou být
          použity k připojení vašeho počítače k internetu. Dalšími automaticky
          shromažďovanými informacemi mohou být informace o počítači a
          připojení, jako jsou typy a verze zásuvných modulů prohlížeče a
          nastavení časového pásma, operační systémy a platformy, úplný tok
          kliknutí na naše webové stránky, přes ně a z nich, který může
          zahrnovat datum a čas; číslo souboru cookie; části webu, které jste si
          prohlíželi nebo vyhledávali. Na některých částech našich webových
          stránek můžeme také používat údaje z prohlížeče, jako jsou soubory
          cookie, soubory cookie flash (známé také jako Flash Local Shared
          Objects) nebo podobné údaje pro účely prevence podvodů a jiné účely.
          Během vašich návštěv můžeme používat softwarové nástroje, jako je
          JavaScript, k měření a shromažďování informací o relaci, včetně doby
          odezvy stránky, chyb při stahování, délky návštěv určitých stránek,
          informací o interakci na stránce (jako je rolování, kliknutí a přejetí
          myší) a způsobů používaných k odchodu ze stránky. Můžeme také
          shromažďovat technické informace, které nám pomohou identifikovat vaše
          zařízení pro účely prevence podvodů a diagnostiky.
        </p>
        <p>
          Při návštěvě, používání nebo procházení platformy automaticky
          shromažďujeme určité informace. Tyto informace{" "}
          <strong>neodhalují vaši konkrétní identitu</strong> (jako je Vaše
          jméno nebo kontaktní údaje), ale mohou zahrnovat informace o zařízení
          a používání, jako je vaše IP adresa, vlastnosti prohlížeče a zařízení,
          operační systém, jazykové preference, odkazující adresy URL, název
          zařízení, země, poloha a další technické informace. Tyto informace
          jsou potřebné především k udržování bezpečnosti a provozu naší
          platformy, pro naše interní analytické účely a podávání zpráv.
        </p>
        <h3>Rozhodné právo</h3>
        <p>
          Tyto Zásady ochrany osobních údajů se řídí českým právem bez ohledu na
          kolizní ustanovení. Souhlasíte s výlučnou jurisdikcí soudů v
          souvislosti s jakoukoli žalobou nebo sporem vzniklým mezi stranami na
          základě těchto Zásad ochrany osobních údajů nebo v souvislosti s nimi,
          s výjimkou osob, které mohou mít právo vznášet nároky podle právního
          rámce na ochranu soukromí nebo právního rámce mezi Švýcarskem a USA
          (Swiss-U.S. Privacy Shield).
        </p>
        <p>
          Tato smlouva a Vaše používání aplikace se řídí českými zákony s
          vyloučením kolizních právních norem. Vaše používání aplikace může
          podléhat také dalším místním, státním, národním nebo mezinárodním
          zákonům.
        </p>
        <p>
          Používáním aplikace HadejSlova.cz nebo přímým kontaktováním nás
          vyjadřujete svůj souhlas s těmito Zásadami ochrany osobních údajů.
          Pokud s těmito Zásadami ochrany osobních údajů nesouhlasíte, neměli
          byste s našimi webovými stránkami pracovat ani využívat naše služby.
          Další používání webových stránek, přímé zapojení do naší činnosti nebo
          po zveřejnění změn těchto Zásad ochrany osobních údajů, které nemají
          významný vliv na používání nebo zveřejňování vašich osobních údajů,
          znamená, že tyto změny přijímáte.
        </p>
        <h3>Váš souhlas</h3>
        <p>
          Aktualizovali jsme naše Zásady ochrany osobních údajů, abychom Vám
          poskytli úplný přehled o tom, co se při návštěvě našich stránek
          nastavuje a jak se to používá. Používáním naší aplikace, registrací
          účtu vyjadřujete souhlas s našimi Zásadami ochrany osobních údajů a
          souhlasíte s jejich podmínkami.
        </p>

        <h3>Soubory cookie</h3>
        <p>
          HadejSlova.cz používají "cookies"; k identifikaci oblastí našich
          webových stránek, které jste navštívili. Cookie je malý soubor dat,
          který váš webový prohlížeč ukládá do vašeho počítače nebo mobilního
          zařízení. Cookies používáme ke uložení výsledků vašich her (bez nich
          by HadejSlova.cz nemohly být funkční). Většinu webových prohlížečů lze
          nastavit tak, aby používání souborů cookie zakázaly. Pokud však
          soubory cookie zakážete, je možné, že nebudete mít správný nebo žádný
          přístup k funkcím na našich webových stránkách. Do souborů cookies
          nikdy neukládáme informace umožňující identifikaci osob.
        </p>
        <h3>Blokování a zakázání souborů cookie a podobných technologií</h3>
        <p>
          Bez ohledu na to, kde se nacházíte, můžete nastavit svůj prohlížeč
          tak, aby blokoval soubory cookie a další podobné technologie. Tato
          akce ale může zablokovat naše základní soubory cookie a znemožnit
          správné fungování našich webových stránek a vy možná nebudete moci
          plně využívat všechny jejich funkce a služby. Měli byste si také
          uvědomit, že pokud soubory cookie ve svém prohlížeči zablokujete,
          můžete také přijít o některé uložené informace (např. uložené
          přihlašovací údaje, předvolby webu). Různé prohlížeče vám umožňují
          různé ovládací prvky. Zakázáním souboru cookie nebo kategorie souborů
          cookie se soubor cookie z prohlížeče nevymaže, to musíte provést sami
          v prohlížeči, další informace naleznete v nabídce nápovědy prohlížeče.
        </p>
        <h3>Soukromí dětí</h3>
        <p>
          Informace od dětí mladších 13 let shromažďujeme pouze za účelem
          zlepšení našich služeb. Pokud jste rodič nebo opatrovník a jste si
          vědomi, že nám vaše dítě poskytlo osobní údaje bez vašeho souhlasu,
          kontaktujte nás. Pokud zjistíme, že jsme shromáždili Osobní údaje od
          osoby mladší 13 let bez ověření souhlasu rodičů, podnikneme kroky k
          odstranění těchto informací z našich serverů.
        </p>
        <h3>Změny našich Zásad ochrany osobních údajů</h3>
        <p>
          Můžeme měnit naše Služby a Zásady ochrany osobních údajů tak, aby
          přesně odrážely naše Služby a zásady. Pokud zákon nevyžaduje jinak,
          budeme vás informovat (například prostřednictvím naší Služby) předtím,
          než provedeme změny těchto Zásad ochrany osobních údajů, a dáme vám
          možnost se s nimi seznámit, než vstoupí v platnost. Pokud pak budete
          Službu nadále používat, budete se řídit aktualizovanými Zásadami
          ochrany osobních údajů. Pokud s těmito nebo jakýmikoli aktualizovanými
          Zásadami ochrany osobních údajů nechcete souhlasit, můžete službu
          přestat používat.
        </p>
        <h3>Služby třetích stran</h3>
        <p>
          Můžeme zobrazovat, zahrnovat nebo zpřístupňovat obsah třetích stran
          (včetně dat, informací, aplikací a dalších služeb, produktů) nebo
          poskytovat odkazy na webové stránky nebo služby třetích stran.
        </p>
        <p>
          Berete na vědomí a souhlasíte s tím, že HadejSlova.cz neodpovídá za
          žádné služby třetích stran, včetně jejich přesnosti, úplnosti,
          včasnosti, platnosti, dodržování autorských práv, zákonnosti,
          slušnosti, kvality nebo jakéhokoli jiného aspektu. HadejSlova.cz
          nepřebírá a nebude mít žádnou odpovědnost vůči Vám ani žádné jiné
          osobě či subjektu za jakékoli služby třetích stran.
        </p>
        <p>
          Služby třetích stran a odkazy na ně jsou poskytovány výhradně pro vaše
          pohodlí a přistupujete k nim a používáte je výhradně na vlastní riziko
          a v souladu s podmínkami těchto třetích stran.
        </p>
        <h3>Kontaktujte nás</h3>
        <p>Neváhejte nás kontaktovat, pokud máte jakékoli dotazy.</p>
      </div>
    </div>
  );
}
